export const SETUSERROLE = "SETUSERROLE";
export const SETMANAGER = "SETMANAGER";
export const SETUSERPOLICY = "SETUSERPOLICY";
export const SETDEPARTLIST = "SETDEPARTLIST";
export const SETUSERLIST = "SETUSERLIST";
export const SETUSERDATA = "SETUSERDATA";
export const SAVEUSERSITEM = "SAVEUSERSITEM";
export const SETUSERDETAIL = "SETUSERDETAIL";
export const SETVENDORCODE = "SETVENDORCODE";
export const SETDESIGNATIONLIST = "SETDESIGNATIONLIST";
export const CLEARDOC = "CLEARDOC";







